import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openTrueAsync,resetState as resetTrueState } from '../features/open/openTrue/openTrueSlice';
import { openDareAsync, resetState as resetDareState, selectOpenDare } from '../features/open/openDare/openDareSlice';
import { openLightDareAsync, resetState as resetLightDareState } from '../features/open/openLightDare/openLightDareSlice';
import TruthOrDareCard from '../components/TruthOrDareCard';
import QuestionCard from '../components/QuestionCard';
import {
  incrementPlayerOneOpenDaresAnswered, incrementPlayerOneOpenKinkyDaresAnswered, incrementPlayerOneOpenLightDaresAnswered, incrementPlayerOneOpenShotsTaken, incrementPlayerOneOpenTruthsAnswered,
  incrementPlayerTwoOpenDaresAnswered, incrementPlayerTwoOpenKinkyDaresAnswered, incrementPlayerTwoOpenLightDaresAnswered, incrementPlayerTwoOpenShotsTaken, incrementPlayerTwoOpenTruthsAnswered, resetGame, toggleOpenPlayerTurn
} from '../features/contestants/contestantsSlice';
import { openKinkyDareAsync, resetState as resetKinkyDareState } from '../features/open/openKinkyDare/openKinkyDareSlice';
import { useNavigate } from 'react-router-dom';
import { setGameReset } from '../features/gamesStatus/gameStatusSlice';
import MenuButton from '../components/MenuButton';
import PopoverCard from '../components/PopoverCard';
import { submitCardInteractionAsync } from '../features/cardInteraction/cardInteractionSlice';
import { recordShots } from '../features/gamesStatus/gameSessionApi';


const OpenGame = () => {
  const playerOne = useSelector((state) => state.contestants.playerOne);
  const playerTwo = useSelector((state) => state.contestants.playerTwo);
  const gameMode = useSelector((state) => state.contestants.gameMode);
  const currentPlayer = useSelector((state) => state.contestants.openPlayerTurn === "playerOne" ? state.contestants.playerOne : state.contestants.playerTwo)
  const currentPlayerTruthsAnswered = useSelector((state) => state.contestants.openPlayerTurn === "playerOne" ? state.contestants.playerOne.openTruthsAnswered : state.contestants.playerTwo.openTruthsAnswered)
  const currentPlayerLightDaresAnswered = useSelector((state) => state.contestants.openPlayerTurn === "playerOne" ? state.contestants.playerOne.openLightDaresAnswered : state.contestants.playerTwo.openLightDaresAnswered)
  const currentPlayerDaresAnswered = useSelector((state) => state.contestants.openPlayerTurn === "playerOne" ? state.contestants.playerOne.openDaresAnswered : state.contestants.playerTwo.openDaresAnswered)
  const currentPlayerKinkyDaresAnswered = useSelector((state) => state.contestants.openPlayerTurn === "playerOne" ? state.contestants.playerOne.openKinkyDaresAnswered : state.contestants.playerTwo.openKinkyDaresAnswered)
  const currentPlayerShotsTaken = useSelector((state) => state.contestants.openPlayerTurn === "playerOne" ? state.contestants.playerOne.openShotsTaken : state.contestants.playerTwo.openShotsTaken)
  const sessionId = useSelector((state) => state.gameStatus?.sessions?.open?.sessionId);
  const openTrue = useSelector((state) => state.openTrue)
  const openLightDare = useSelector((state) => state.openLightDare)
  const openDare = useSelector((state) => state.openDare)
  const openKinkyDare = useSelector((state) => state.openKinkyDare)
  const [cardSwitch, setCardSwitch] = useState(true)
  const [truthOrDare, setTruthOrDare] = useState("")
  const [question, setQuestion] = useState("")
  const [questionTimer, setQuestionTimer] = useState("")
  const [drinkQuestion, setDrinkQuestion] = useState("")
  const [attributes, setAttributes] = useState([])
  const [errorPopoverOpen, setErrorPopoverOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [buttonOneText, setButtonOneText] = useState('');
  const [onButtonOne, setOnButtonOne] = useState('');
  const [showButtonOne, setShowButtonOne] = useState(false);
  const gameType = 'open'

  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    setQuestion(openTrue.NewQuestion)
    setQuestionTimer(openTrue.NewQuestionTimer)
    setDrinkQuestion(openTrue.DrinkQuestion)
    setAttributes(openTrue.Attributes)
  }, [openTrue.NewQuestion])

  useEffect(() => {
    setQuestion(openLightDare.NewQuestion)
    setQuestionTimer(openLightDare.NewQuestionTimer)
    setDrinkQuestion(openLightDare.DrinkQuestion)
    setAttributes(openLightDare.Attributes)
  }, [openLightDare.NewQuestion])

  useEffect(() => {
    setQuestion(openDare.NewQuestion)
    setQuestionTimer(openDare.NewQuestionTimer)
    setDrinkQuestion(openDare.DrinkQuestion)
    setAttributes(openDare.Attributes)
  }, [openDare.NewQuestion])

  useEffect(() => {
    setQuestion(openKinkyDare.NewQuestion)
    setQuestionTimer(openKinkyDare.NewQuestionTimer)
    setDrinkQuestion(openKinkyDare.DrinkQuestion)
    setAttributes(openKinkyDare.Attributes)
  }, [openKinkyDare.NewQuestion])

  const handleError = (error) => {
    if (error) {
        if (error.status === 403) {
            setErrorMessage('To use this feature, you need to purchase premium.');
            setButtonOneText('Go to Payment Page');
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> navigate("/account/paymentpage"))
        } else if (error.status === 401) {
            setErrorMessage('You are not logged in.');
            setButtonOneText('Log In');
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> navigate("/account/login"))
        } else if (error.status === 404) {
            setErrorMessage('For some reason we couldnt find another card for you, it might be a problem on our side, or youve finished all the cards for this deck!');
            setButtonOneText('Try again');
            setQuestion("For some reason we couldnt find another card for you, it might be a problem on our side, or youve finished all the cards for this deck!")
            setShowButtonOne(true);
            setOnButtonOne(() =>()=> setErrorPopoverOpen(false))
        }else {
            setErrorMessage('An unexpected error occurred.');
        }
    } else {
        setErrorMessage('An unexpected error occurred.');
    }
    setErrorPopoverOpen(true);
};
const handleClosePopover = () => {
  setErrorPopoverOpen(false);
};

  const OpenTrue = async () => {
    try {
      await dispatch(openTrueAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap()
      setTruthOrDare('Truth')
      toggleCardswitch()
    } catch (error) {
      console.error('Caught error in OpenTrue:', error);
      handleError(error); // ✅ Correctly handles popover
    } 
    // setQuestion((state) => state.openTrue.NewQuestion)

  }

  const OpenLightDare = async () => {
    try {
      await dispatch(openLightDareAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap()
      setTruthOrDare('Light Dare')
      toggleCardswitch()
    } catch (error) {
      console.error('Caught error in OpenLightDare:', error);
      handleError(error); // ✅ Correctly handles popover
    } 
    // setQuestion((state) => state.openLightDare.NewQuestion)
  }

  const OpenDare = async () => {
      try {
        await dispatch(openDareAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap()
        setTruthOrDare('Dare')
        toggleCardswitch()
      } catch (error) {
        console.error('Caught error in OpenDare:', error);
        handleError(error); // ✅ Correctly handles popover
      } 
    // setQuestion((state) => state.openDare.NewQuestion)
  }

  const OpenKinkyDare = async () => {
    try {
      await dispatch(openKinkyDareAsync({ gender: currentPlayer.gender, player: currentPlayer.id })).unwrap()
      setTruthOrDare('Kinky Dare')
      toggleCardswitch()
    } catch (error) {
      console.error('Caught error in OpenKinkyDare:', error);
      handleError(error); // ✅ Correctly handles popover
    } 
    // setQuestion((state) => state.openKinkyDare.NewQuestion)
  }


  const toggleParticipantsSwitch = () => {
    dispatch(toggleOpenPlayerTurn())
  };
  const addshots = () => {
    if (currentPlayer == playerOne) {
      dispatch(incrementPlayerOneOpenShotsTaken())
    } else { dispatch(incrementPlayerTwoOpenShotsTaken()) }
  }

  const bothDrink = () => {
    dispatch(incrementPlayerOneOpenShotsTaken())
    dispatch(incrementPlayerTwoOpenShotsTaken())
    toggleParticipantsSwitch()
    if (sessionId) recordShots({ sessionId, playerOneShot: true, playerTwoShot: true });
  }

  const addAsnweredQuestionCount = () => {
    if (currentPlayer == playerOne) {
      if (truthOrDare === "Light Dare") {
        dispatch(incrementPlayerOneOpenLightDaresAnswered())
      } else if (truthOrDare === "Truth") {
        dispatch(incrementPlayerOneOpenTruthsAnswered())
      } else if (truthOrDare === "Kinky Dare") {
        dispatch(incrementPlayerOneOpenKinkyDaresAnswered())
      } else {
        dispatch(incrementPlayerOneOpenDaresAnswered())
      }
    } else {
      if (truthOrDare === "Light Dare") {
        dispatch(incrementPlayerTwoOpenLightDaresAnswered())
      } else if (truthOrDare === "Truth") {
        dispatch(incrementPlayerTwoOpenTruthsAnswered())
      } else if (truthOrDare === "Kinky Dare") {
        dispatch(incrementPlayerTwoOpenKinkyDaresAnswered())
      } else {
        dispatch(incrementPlayerTwoOpenDaresAnswered())
      }
    }
  }

  const swapTurns = () => {
    addAsnweredQuestionCount()
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
          gameType: 'open',
          type_of_card: truthOrDare,
          player: currentPlayer.id,
          skipped: false
          }));
    setQuestion("")
  }
  const swapTurnsAndAddShot = () => {
    addshots()
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
      gameType: 'open',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: true,
      stopped_by: currentPlayer.id,
      shot_player: currentPlayer.id,
      }));
    setQuestion("")
  }
  const swapSkippedTurns = (stoppedById = currentPlayer.id) => {
    toggleParticipantsSwitch()
    toggleCardswitch()
    dispatch(submitCardInteractionAsync({
      gameType: 'open',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: true,
      stopped_by: stoppedById,
      }));
    setQuestion("")
  }
  const setPlayerAddShotAndSwap = (participant) => {
    const cardWasSkipped = participant === currentPlayer

    dispatch(submitCardInteractionAsync({
      gameType: 'open',
      type_of_card: truthOrDare,
      player: currentPlayer.id,
      skipped: cardWasSkipped,
      stopped_by: cardWasSkipped ? participant.id : null,
      shot_player: participant.id,
    }))

    addAsnweredQuestionCount()

    if (participant === playerTwo) {
      dispatch(incrementPlayerTwoOpenShotsTaken())
    } else {
      dispatch(incrementPlayerOneOpenShotsTaken())
    }

    toggleParticipantsSwitch()
    toggleCardswitch()
    setQuestion("")
  }

  const toggleCardswitch = () => {
    setCardSwitch(!cardSwitch);
  };
  const restartGame = () =>{
    dispatch(resetGame(gameType))
    dispatch(resetDareState())
    dispatch(resetLightDareState())
    dispatch(resetKinkyDareState())
    dispatch(resetTrueState())
    setCardSwitch(true)
  }
  const onQuitWithoutSave = () => {
    restartGame()
    dispatch(setGameReset(gameType))
    navigate("/chooselevel")
  }
  const onSaveAndQuit = () => {
    navigate("/chooselevel")
  }
  const onSaveAndDownload = () => {
    navigate("/download")
  }
  const onDiscardAndDownload = () => {
    restartGame()
    dispatch(setGameReset(gameType))
    navigate("/download")
  }

  return (
    <div>
      <MenuButton
        showRestart={true}
        showChangeAccessories={true}
        showQuitGame={true}
        showSwitchGameMode={true}
        showDownload={true}
        onRestartClick={restartGame}
        onQuitGameClick={onQuitWithoutSave}
        onSaveAndQuit={onSaveAndQuit}
        onSaveAndDownload={onSaveAndDownload}
        onDiscardAndDownload={onDiscardAndDownload}
        gameType={gameType}
      />
        <PopoverCard
      mainText={errorMessage}
      open={errorPopoverOpen}
      onClose={()=>navigate('/')}
      showButtonOne={showButtonOne}
      textButtonOne={buttonOneText}
      onButtonOne={onButtonOne}
      />

      {cardSwitch ? <TruthOrDareCard
        fetchTruth={OpenTrue}
        fetchLightDare={OpenLightDare}
        fetchDare={OpenDare}
        fetchKinky={OpenKinkyDare}
        playerOne={playerOne}
        playerTwo={playerTwo}
        currentPlayer={currentPlayer}
        currentPlayerTruthsAnswered={currentPlayerTruthsAnswered}
        currentPlayerLightDaresAnswered={currentPlayerLightDaresAnswered}
        currentPlayerDaresAnswered={currentPlayerDaresAnswered}
        currentPlayerKinkyDaresAnswered={currentPlayerKinkyDaresAnswered}
        currentPlayerShotsTaken={currentPlayerShotsTaken}
        gameType={"open"}
        bothDrink={bothDrink}
        lastTrue={openTrue.LastCard}
        lastLight={openLightDare.LastCard}
        lastDare={openDare.LastCard}
        lastKinky={openKinkyDare.LastCard}
      />
        :
        <QuestionCard
          question={question}
          questionTimer={questionTimer}
          drinkQuestion={drinkQuestion}
          attributes={attributes}
          swapTurns={swapTurns}
          swapTurnsAndAddShot={swapTurnsAndAddShot}
          swapSkippedTurns={swapSkippedTurns}
          truthOrDare={truthOrDare}
          currentPlayer={currentPlayer}
          playerOne={playerOne}
          playerTwo={playerTwo}
          setPlayerAddShotAndSwap={setPlayerAddShotAndSwap}
        />}
    </div>
  )
}

export default OpenGame